import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  updateUserPreference,
  fetchNewsTableColumnNames,
  fetchNewsData,
  activateDeactivateNewsData,
  updateNewsData,
  addNewsData,
  deleteNewsData
} from "../../../slices/thunks";
import { getAuthUser } from "../../../helpers/utils";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import DeleteModal from "../../../Components/Common/DeleteModal";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../../Components/Hooks/usePermissions";
import NewsForm from "../../../Components/Common/AddNewsForm/AddNewsForm";
import { useNavigate } from "react-router-dom";
import NewsFormData from "../../../Components/Common/AddNewsForm/AddNewsDataForm";

const labels = [
  {
    id: 1,
    labelName: "Link",
    fieldName: "text-box",
    name: "Link",
    value: "URL",
    required: true,
    errorMessage: "LinkRequired",
  },
  {
    id: 2,
    labelName: "Title",
    fieldName: "text-box",
    name: "Title",
    value: "Title",
    required: true,
    errorMessage: "TitleRequired",
  },
  {
    id: 3,
    labelName: "Content",
    fieldName: "textarea-box",
    name: "Content",
    value: "Content",
    required: true,
    errorMessage: "ContentRequired",
  }
];

const actionConfig = {
    showCheckboxColumn: true,
    action: false
};

function NewsData() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { user } = getAuthUser();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const { News, loading, tableColumnNames } = useSelector(
    (state) => ({
      tableColumnNames: state.News.tableColumnNames,
      loading: state.News.loading,
      News: state.News.newsData,
    })
  );
  
  const handleClassesClicks = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (user, value) => {
    setSelectedRow(user);
    setIsAddOrEdit(value);
    setShow(true);
  };
    

  const onSubmitHandler = (values, { resetForm }) => {
    // Prepare the payload
    const newsObj = {
      URL: values.Link.trim(),
      Title: values.Title.trim(),
      Content: values.Content.trim(),
    };

    if (isAddOrEdit === "isEdit" && selectedRow) {
      newsObj["ID"] = selectedRow.ID;
    }

    if (isAddOrEdit === "isAdd") {
      dispatch(addNewsData(newsObj));
    } else {
      dispatch(updateNewsData(newsObj));
    }
    resetForm();
    setShow(false);
  };

  const saveUserPreferences = async () => {
    const preferencesPayload = {
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ID] = selectedColumns.includes(column.ID);
        return acc;
      }, {}),
    };

    setModalOpen(false);
    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchNewsTableColumnNames({
          module: "NEWSDATA",
        })
      );

    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteNewsData({ IDs: selectedIds }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  const onActiveOrDeactiveChange = (item, e) => {
    dispatch(activateDeactivateNewsData({ ID: item.ID }))
  };

  // Compute permission
  const permission = (() => {
    return usePermissions(1, 17);
  })();


  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(
          fetchNewsTableColumnNames({
            module: "NEWSDATA",
          })
        ).unwrap();
        await dispatch(fetchNewsData());
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("NewsData")} />
          </Col>
        </Row>

        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4 ">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                    </div>
                  </Col>
                  
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                        disabled={loading}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                      <Button
                            className="btn btn-soft me-1"
                            onClick={() => navigate(-1)}
                            >
                            {t("Back")}
                      </Button>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
             
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner
                      style={{ height: "3rem", width: "3rem" }}
                      className="me-2"
                    >
                      Loading...
                    </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                     <CommonDataTable
                      data={News}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      actionConfig={actionConfig}
                      permission={permission}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
      <CommonAddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        labels={labels}
        isAddOrEdit={isAddOrEdit}
        selectedItemData={selectedRow}
        FormBody={NewsFormData}
        title={isAddOrEdit === "isAdd" ? t("AddNewsData") : t("EditNewsData")}
        size="lg"
      />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={saveUserPreferences}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={t("confirmDelete")}
      />

    </div>
  );
}

export default NewsData;
